import {
  FETCH_CURRENCIES_INFO_REQUEST,
  FETCH_CURRENCIES_INFO_SUCCESS,
  FETCH_CURRENCIES_INFO_FAILURE,
} from 'actionTypes';
import createReducer from './createReducer';

export const initialState = {
  entities: {},
  ids: [],
  isFetching: false,
  isInitialized: false,
};

export const currenciesInfo = createReducer(initialState, {
  [FETCH_CURRENCIES_INFO_REQUEST]: state => ({
    ...state,
    isFetching: true,
  }),

  [FETCH_CURRENCIES_INFO_SUCCESS]: (state, action) => ({
    ...state,
    entities: {
      ...state.entities,
      ...action.payload.entities,
    },
    ids: Array.from(new Set([...state.ids, ...action.payload.ids]).values()),
    isInitialized: true,
    isFetching: false,
  }),

  [FETCH_CURRENCIES_INFO_FAILURE]: state => ({
    ...state,
    isFetching: false,
    isRequestFailed: true,
    isInitialized: true,
  }),
});

export default currenciesInfo;
